// @ts-check
import React from 'react';
import { drawerClasses } from '@liquidweb-dev/undercurrent/Drawer';
import SwipeableDrawer from '@liquidweb-dev/undercurrent/SwipeableDrawer';
import DrawerFooter from '@liquidweb-dev/undercurrent/DrawerFooter';
import useLeftHandLayout from '../context';
import SmallNavAccount from './Account';
import LeftNavList from '../LeftNav/List';
import SmallNavCreateFooter from './CreateFooter';

export function SmallNavDrawer() {
	const { mobileOpen, setMobileOpen, topSize } = useLeftHandLayout();

	return (
		<SwipeableDrawer
			hideBackdrop
			open={mobileOpen}
			onOpen={() => setMobileOpen(true)}
			onClose={() => setMobileOpen(false)}
			component="nav"
			anchor="left"
			variant="temporary"
			sx={{
				pointerEvents: 'none',
				[`& .${drawerClasses.paper}`]: {
					pointerEvents: 'all',
					width: '100%',
					height: `calc(100dvh - ${topSize}px)`,
					marginTop: `${topSize}px`,
					padding: 0,
					backgroundColor: (theme) => theme.palette.uc.bg.weak,
				},
			}}
		>
			<SmallNavAccount />
			<LeftNavList flex="0% 1 1" />
			<DrawerFooter sx={{ padding: 0 }}>
				<SmallNavCreateFooter />
			</DrawerFooter>
		</SwipeableDrawer>
	);
}

export default SmallNavDrawer;
